import { Metamodel } from 'app/model/base/model';
import { FileBasedSettings, FILEMODE } from './file-based-settings';
import { DataFlowExpression } from '../dataflowexpression';
import { XmlDataset } from 'app/model/dataset/xml.dataset';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { StringDataFlowType } from '../dataflow-datatype';
import { compressionOptionValues } from 'app/shared/components/compression-setting/compression-options';
import { IViolation } from 'app/model/base/annotation';
import { DataFlowSource } from '../dataflow-source';

import { compressionCodecType, IValidationContext } from 'shell-models-lib';
import { validateFilePathOfFileBasedSettings } from './dataset-settings-validation-utils';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.xml.dataflowSettings,
    validator: XmlSettings.validateXmlSettings
})
export class XmlSettings extends FileBasedSettings {
    public compressionType: string;
    public compressionLevel: DataFlowExpression;
    public nullValue: DataFlowExpression;
    public encoding: DataFlowExpression;

    public getDatasetType(): string {
        return Metamodel.modelFor(XmlDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Xml;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-Xml';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.compressionLevel = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, compressionOptionValues.Fastest);
        this.nullValue = this.transform.createTemplatableExpression();
        this.encoding = this.transform.createTemplatableExpression();
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateXmlSettings(settings: XmlSettings, context: IValidationContext): Promise<IViolation[]> {
        const source = settings.transform as DataFlowSource;
        if (source.isInlineDataset && source.datasetSettings && source.datasetSettings.getFormat() === DatasetFormatType.Xml) {
            const violations: IViolation[] = [];
            violations.push(...(await validateFilePathOfFileBasedSettings(settings, false, context)));
            if (settings.fileMode === FILEMODE.FILE && settings.compressionType === compressionCodecType.gzip &&
                !settings.fileName.templateExpression && !!settings.fileName.expression && !settings.fileName.expression.endsWith('.gz')) {
                violations.push({
                    message: () => stringResources.Dataset_FileFormat_GZipFilenameError,
                    context: source
                });
            }
            return violations.length > 0 ? violations : undefined;
        }
        return undefined;
    }
}
